module.exports = __webpack_public_path__ + "static/other/grocery_bagger.0541fb73.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/grocery_bagger.json
// module id = 2618
// module chunks = 0